"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryPlaceRoom = exports.tryAccreteRoom = exports.getAllPossiblePositions = exports.placeHyperspaceRoom_inCenter = exports.setDoor = exports.createHyperspaceRoom = exports.initHyperspace = void 0;
var diveTileData_1 = require("@dive/tilemap/diveTileData");
var diveTileData_sidecar_1 = require("@dive/tilemap/diveTileData-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var diveTilemapHyperspace_sidecar_1 = require("@dive/tilemap/diveTilemapHyperspace-sidecar");
var diveTilemapPart_sidecar_1 = require("@dive/tilemap/diveTilemapPart-sidecar");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
function initHyperspace() {
    diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.create();
    diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.clear();
}
exports.initHyperspace = initHyperspace;
function createHyperspaceRoom(info, options) {
    var hs = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.get();
    diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.clear();
    var border = 1;
    var minSize = options.minSize;
    if (options.maxSize > 16) {
        options.maxSize = 16;
    }
    var maxW = options.maxSize - border * 2;
    var maxH = options.maxSize - border * 2;
    var room_w = info.rnd.i(minSize, maxW);
    var room_h = info.rnd.i(minSize, maxH);
    console.log('create room', room_w, room_h, info.rnd.getCurrentSeed());
    var room_i = Math.floor(hs.width / 2 - room_w / 2);
    var room_j = Math.floor(hs.height / 2 - room_h / 2);
    var td = diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.Floor);
    diveTilemapUtils_sidecar_1.diveTilemapUtils.fillRect(hs, room_i, room_j, room_w, room_h, td);
    if (info.rnd.chance(0.5)) {
        // Add a second rectangle
        var room_w2 = info.rnd.i(minSize, maxW);
        var room_h2 = info.rnd.i(minSize, maxH);
        // Centered, maybe don't center sometimes?
        var room_i2 = Math.floor(hs.width / 2 - room_w2 / 2);
        var room_j2 = Math.floor(hs.height / 2 - room_h2 / 2);
        if (info.rnd.chance(0.5)) {
            room_i2 += info.rnd.intSymmetric(Math.floor((room_w - room_w2) / 4));
            room_j2 += info.rnd.intSymmetric(Math.floor((room_h - room_h2) / 4));
        }
        room_i2 = mathUtils_sidecar_1.mathUtils.clamp(room_i2, 0 + 1, hs.width - room_w2 - 1 - 1 - 1);
        room_j2 = mathUtils_sidecar_1.mathUtils.clamp(room_j2, 0 + 1, hs.height - room_h2 - 1 - 1 - 1);
        diveTilemapUtils_sidecar_1.diveTilemapUtils.fillRect(hs, room_i2, room_j2, room_w2, room_h2, td);
    }
    // Collect possible door positions
    var doorsN = [];
    var doorsS = [];
    var doorsW = [];
    var doorsE = [];
    // Scan from top to bottom to find first and last floor tile
    for (var i = 0; i < hs.width; i++) {
        var firstFloorJ = -1;
        var lastFloorJ = -1;
        for (var j = 0; j < hs.height; j++) {
            var tile = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.getSafe(i, j);
            if (tile && tile.tile1.type === diveTileData_1.EDiveTile.Floor) {
                if (firstFloorJ === -1) {
                    firstFloorJ = j;
                }
                lastFloorJ = j;
            }
        }
        if (firstFloorJ > 0) {
            doorsN.push({ i: i, j: firstFloorJ - 1 });
        }
        if (lastFloorJ > -1 && lastFloorJ < hs.height - 1) {
            doorsS.push({ i: i, j: lastFloorJ + 1 });
        }
    }
    for (var j = 0; j < hs.height; j++) {
        var firstFloorI = -1;
        var lastFloorI = -1;
        for (var i = 0; i < hs.width; i++) {
            var tile = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.getSafe(i, j);
            if (tile && tile.tile1.type === diveTileData_1.EDiveTile.Floor) {
                if (firstFloorI === -1) {
                    firstFloorI = i;
                }
                lastFloorI = i;
            }
        }
        if (firstFloorI > 0) {
            doorsW.push({ i: firstFloorI - 1, j: j });
        }
        if (lastFloorI > -1 && lastFloorI < hs.width - 1) {
            doorsE.push({ i: lastFloorI + 1, j: j });
        }
    }
    // Add random doors
    if (doorsN.length > 0) {
        var doorN = info.rnd.sample(doorsN);
        setDoor(info, doorN.i, doorN.j, 'n');
    }
    if (doorsS.length > 0) {
        var doorS = info.rnd.sample(doorsS);
        setDoor(info, doorS.i, doorS.j, 's');
    }
    if (doorsW.length > 0) {
        var doorW = info.rnd.sample(doorsW);
        setDoor(info, doorW.i, doorW.j, 'w');
    }
    if (doorsE.length > 0) {
        var doorE = info.rnd.sample(doorsE);
        setDoor(info, doorE.i, doorE.j, 'e');
    }
}
exports.createHyperspaceRoom = createHyperspaceRoom;
function setDoor(info, i, j, doorHint) {
    var td = diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.DoorClosed);
    var hst = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.getUnsafe(i, j);
    diveTilemapPart_sidecar_1.diveTilemapPart.setTile(hst, td);
    hst.gen_doorHint = doorHint;
}
exports.setDoor = setDoor;
function placeHyperspaceRoom_inCenter(info) {
    var hs = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.get();
    var tm = diveTilemap_sidecar_1.diveTilemap.get();
    var centerI = Math.floor((tm.width - hs.width) / 2);
    var centerJ = Math.floor((tm.height - hs.height) / 2);
    tryPlaceRoom(info, centerI, centerJ, true);
}
exports.placeHyperspaceRoom_inCenter = placeHyperspaceRoom_inCenter;
function getAllPossiblePositions(info) {
    var possiblePositions = [];
    var tm = diveTilemap_sidecar_1.diveTilemap.get();
    for (var j = 0; j < tm.height; j++) {
        for (var i = 0; i < tm.width; i++) {
            possiblePositions.push({ i: i, j: j });
        }
    }
    info.rnd.shuffle(possiblePositions);
    return possiblePositions;
}
exports.getAllPossiblePositions = getAllPossiblePositions;
function tryAccreteRoom(info) {
    var possiblePositions = getAllPossiblePositions(info);
    while (possiblePositions.length > 0) {
        var pp = possiblePositions.pop();
        if (!pp) {
            break;
        }
        var valid = tryPlaceRoom(info, pp.i, pp.j, false);
        // console.log('attempt', pp.i, pp.j, valid)
        if (valid) {
            return true;
        }
    }
}
exports.tryAccreteRoom = tryAccreteRoom;
function tryPlaceRoom(info, oi, oj, force) {
    if (force === void 0) { force = false; }
    var valid = true || force;
    var hasValidDoor = false || force;
    var hs = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.get();
    var tm = diveTilemap_sidecar_1.diveTilemap.get();
    var validDoors = [];
    if (!force) {
        for (var j = 0; j < hs.height; j++) {
            if (!valid) {
                break;
            }
            for (var i = 0; i < hs.width; i++) {
                var hsTile = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.getSafe(i, j);
                if (!hsTile) {
                    valid = false;
                    break;
                }
                var tmTile = diveTilemap_sidecar_1.diveTilemap.getSafe(oi + i, oj + j);
                if (!tmTile) {
                    valid = false;
                    continue;
                }
                if (hsTile.tile1.type === diveTileData_1.EDiveTile.Acid) {
                    continue;
                }
                if (tmTile.tile1.type !== diveTileData_1.EDiveTile.Acid) {
                    valid = false;
                    break;
                }
                if (hsTile.tile1.type === diveTileData_1.EDiveTile.DoorClosed) {
                    // See if this door connects
                    if (hsTile.gen_doorHint === 'n') {
                        var tmTileN = diveTilemap_sidecar_1.diveTilemap.getSafeOffset(tmTile, 0, -1);
                        if (tmTileN && tmTileN.tile1.type === diveTileData_1.EDiveTile.Floor) {
                            hasValidDoor = true;
                            validDoors.push(hsTile);
                        }
                    }
                    if (hsTile.gen_doorHint === 's') {
                        var tmTileS = diveTilemap_sidecar_1.diveTilemap.getSafeOffset(tmTile, 0, 1);
                        if (tmTileS && tmTileS.tile1.type === diveTileData_1.EDiveTile.Floor) {
                            hasValidDoor = true;
                            validDoors.push(hsTile);
                        }
                    }
                    if (hsTile.gen_doorHint === 'w') {
                        var tmTileW = diveTilemap_sidecar_1.diveTilemap.getSafeOffset(tmTile, -1, 0);
                        if (tmTileW && tmTileW.tile1.type === diveTileData_1.EDiveTile.Floor) {
                            hasValidDoor = true;
                            validDoors.push(hsTile);
                        }
                    }
                    if (hsTile.gen_doorHint === 'e') {
                        var tmTileE = diveTilemap_sidecar_1.diveTilemap.getSafeOffset(tmTile, 1, 0);
                        if (tmTileE && tmTileE.tile1.type === diveTileData_1.EDiveTile.Floor) {
                            hasValidDoor = true;
                            validDoors.push(hsTile);
                        }
                    }
                }
                else {
                }
            }
        }
    }
    if (valid && hasValidDoor) {
        for (var j = 0; j < hs.height; j++) {
            for (var i = 0; i < hs.width; i++) {
                var hsTile = diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.getSafe(i, j);
                if (!hsTile) {
                    continue;
                }
                if (hsTile.tile1.type === diveTileData_1.EDiveTile.Acid) {
                    continue;
                }
                var tmTile = diveTilemap_sidecar_1.diveTilemap.getSafe(oi + i, oj + j);
                if (!tmTile) {
                    continue;
                }
                if (hsTile.tile1.type === diveTileData_1.EDiveTile.DoorClosed) {
                    // Only copy connected doors
                    if (validDoors.includes(hsTile)) {
                        diveTilemapPart_sidecar_1.diveTilemapPart.setTile(tmTile, hsTile.tile1);
                    }
                    continue;
                }
                // console.log('placing', tmTile, hsTile.tile1)
                diveTilemapPart_sidecar_1.diveTilemapPart.setTile(tmTile, hsTile.tile1);
            }
        }
    }
    return valid && hasValidDoor;
}
exports.tryPlaceRoom = tryPlaceRoom;
